// Tipagem intermediária
export type Substancia = {
    nome: string,
    formula: string
};

export type DadosUnifac = {
    substancia: Substancia | undefined,
    subgrupos: SubgrupoUnifac
};

export type DadosUnifacNorm = {
    substancia: Substancia | undefined,
    subgrupos: number[],
};

export type DadosAntoine = {
    substancia: Substancia | undefined,
    unidadeTemperatura: "°C" | "K",
    unidadePressao: "kPa",
    A: number,
    B: number,
    C: number
};

export type DadosUA = {
    unifac: DadosUnifacNorm,
    antoine: DadosAntoine
};

type SubgrupoUnifac = {
    "CH3": number,
    "CH2": number,
    "CH": number,
    "C": number,
    "ACH": number,
    "ACCH3": number,
    "ACCH2": number,
    "OH": number,
    "H2O": number,
    "CH3CO": number,
    "CH2CO": number,
    "CH3O": number,
    "CH2O": number,
    "CH-O": number,
    "CH3NH": number,
    "CH2NH": number,
    "CHNH": number,
    "CH3CN": number,
    "CH2CN": number
};

export default class OffStorage {

    substancias: Substancia[] = [
        { nome: "Acetona", formula: "C3H6O" },
        { nome: "Acetato de Metila", formula: "C3H6O2" },
        { nome: "Acetonitrila", formula: "C2H3N" },
        { nome: "Ácido Acético", formula: "C2H4O2" },
        { nome: "Água", formula: "H2O" },
        { nome: "Benzeno", formula: "C6H6" },
        { nome: "n-Butano", formula: "C4H10" },
        { nome: "1-Butanol", formula: "C4H10O" },
        { nome: "Ciclo-hexano", formula: "C6H12" },
        { nome: "Ciclopentano", formula: "C5H10" },
        { nome: "Clorobenzeno", formula: "C6H5Cl" },
        { nome: "Dietilamina", formula: "C4H11N" },
        { nome: "Dimetilamina", formula: "(CH3)2NH" },
        { nome: "Etanol", formula: "C2H5OH" },
        { nome: "Éter Dietílico", formula: "(C2H5)2O" },
        { nome: "Éter Dimetílico", formula: "C2H6O" },
        { nome: "Etilbenzeno", formula: "C8H10" },
        { nome: "Fenol", formula: "C6H6O" },
        { nome: "n-Heptano", formula: "C7H16" },
        { nome: "n-Hexano", formula: "C6H14" },
        { nome: "Isobutano", formula: "C4H10" },
        { nome: "Metanol", formula: "CH3OH" },
        { nome: "1-Propanol", formula: "C3H8O" },
        { nome: "2-Propanol", formula: "C3H8O" },
        { nome: "Tetracloreto de Carbono", formula: "CCl4" },
        { nome: "Tolueno", formula: "C7H8" }
    ];

    dadosAntoine: DadosAntoine[] = [
        {
            substancia: this.substancias.find(item => item.nome == "Água"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 16.3872, B: 3885.7, C: 230.17
        },
        {
            substancia: this.substancias.find(item => item.nome == "Acetona"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 14.3145, B: 2756.22, C: 228.06
        },
        {
            substancia: this.substancias.find(item => item.nome == "Ácido Acético"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 15.0717, B: 3580.8, C: 224.65
        },
        {
            substancia: this.substancias.find(item => item.nome == "Acetonitrila"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 14.895, B: 3413.1, C: 250.523
        },
        {
            substancia: this.substancias.find(item => item.nome == "Benzeno"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.7819, B: 2726.81, C: 217.572
        },
        {
            substancia: this.substancias.find(item => item.nome == "n-Butano"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.6608, B: 2154.7, C: 238.789
        },
        {
            substancia: this.substancias.find(item => item.nome == "Isobutano"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 14.6047, B: 2740.95, C: 166.67
        },
        {
            substancia: this.substancias.find(item => item.nome == "1-Butanol"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 15.3144, B: 3212.43, C: 182.739
        },
        {
            substancia: this.substancias.find(item => item.nome == "Tetracloreto de Carbono"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 14.0572, B: 2914.23, C: 232.148
        },
        {
            substancia: this.substancias.find(item => item.nome == "Clorobenzeno"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.8635, B: 3174.78, C: 211.7
        },
        {
            substancia: this.substancias.find(item => item.nome == "Ciclo-hexano"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.6568, B: 2723.44, C: 220.618
        },
        {
            substancia: this.substancias.find(item => item.nome == "Ciclopentano"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.9727, B: 2653.9, C: 234.51
        },
        {
            substancia: this.substancias.find(item => item.nome == "Éter Dietílico"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 14.0735, B: 2511.29, C: 231.2
        },
        {
            substancia: this.substancias.find(item => item.nome == "Etanol"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 16.8958, B: 3795.17, C: 230.918
        },
        {
            substancia: this.substancias.find(item => item.nome == "Etilbenzeno"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.9726, B: 3259.93, C: 212.3
        },
        {
            substancia: this.substancias.find(item => item.nome == "n-Heptano"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.8622, B: 2910.26, C: 216.432
        },
        {
            substancia: this.substancias.find(item => item.nome == "n-Hexano"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.8193, B: 2696.04, C: 224.317
        },
        {
            substancia: this.substancias.find(item => item.nome == "Metanol"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 16.5785, B: 3638.27, C: 239.5
        },
        {
            substancia: this.substancias.find(item => item.nome == "Fenol"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 14.4387, B: 3507.8, C: 175.4
        },
        {
            substancia: this.substancias.find(item => item.nome == "Tolueno"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 13.932, B: 3056.96, C: 217.625
        },
        {
            substancia: this.substancias.find(item => item.nome == "Acetato de Metila"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 14.2456, B: 2662.78, C: 219.690
        },
        {
            substancia: this.substancias.find(item => item.nome == "1-Propanol"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 16.1154, B: 3483.67, C: 205.807
        },
        {
            substancia: this.substancias.find(item => item.nome == "2-Propanol"),
            unidadeTemperatura: "°C", unidadePressao: "kPa", A: 16.6796, B: 3640.2, C: 219.61
        }
    ];

    dadosUnifac: DadosUnifac[] = [
        {
            substancia: this.substancias.find(item => item.nome == "n-Butano"),
            subgrupos: {
                "CH3": 2, "CH2": 2, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Metanol"),
            subgrupos: {
                "CH3": 1, "CH2": 0, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 1,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Isobutano"),
            subgrupos: {
                "CH3": 3, "CH2": 0, "CH": 1, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Benzeno"),
            subgrupos: {
                "CH3": 0, "CH2": 0, "CH": 0, "C": 0, "ACH": 6, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Tolueno"),
            subgrupos: {
                "CH3": 0, "CH2": 0, "CH": 0, "C": 0, "ACH": 5, "ACCH3": 1, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Etilbenzeno"),
            subgrupos: {
                "CH3": 1, "CH2": 0, "CH": 0, "C": 0, "ACH": 5, "ACCH3": 0, "ACCH2": 1, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Etanol"),
            subgrupos: {
                "CH3": 1, "CH2": 1, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 1,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Acetona"),
            subgrupos: {
                "CH3": 1, "CH2": 0, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 1, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Éter Dimetílico"),
            subgrupos: {
                "CH3": 1, "CH2": 0, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 1, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Éter Dietílico"),
            subgrupos: {
                "CH3": 2, "CH2": 1, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 1, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Dimetilamina"),
            subgrupos: {
                "CH3": 1, "CH2": 0, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 1,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Dietilamina"),
            subgrupos: {
                "CH3": 1, "CH2": 1, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 1, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Acetonitrila"),
            subgrupos: {
                "CH3": 0, "CH2": 0, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 1, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "n-Heptano"),
            subgrupos: {
                "CH3": 2, "CH2": 5, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Acetato de Metila"),
            subgrupos: {
                "CH3": 0, "CH2": 0, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 0, "CH3CO": 1, "CH2CO": 0, "CH3O": 1, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        },
        {
            substancia: this.substancias.find(item => item.nome == "Água"),
            subgrupos: {
                "CH3": 0, "CH2": 0, "CH": 0, "C": 0, "ACH": 0, "ACCH3": 0, "ACCH2": 0, "OH": 0,
                "H2O": 1, "CH3CO": 0, "CH2CO": 0, "CH3O": 0, "CH2O": 0, "CH-O": 0, "CH3NH": 0,
                "CH2NH": 0, "CHNH": 0, "CH3CN": 0, "CH2CN": 0
            }
        }
    ];

    normSubgruposUnifac(obj: SubgrupoUnifac) {
        return [obj.CH3, obj.CH2, obj.CH, obj.C, obj.ACH, obj.ACCH3, obj.ACCH2, obj.OH, obj.H2O, obj.CH3CO, obj.CH2CO, obj.CH3O, obj.CH2O, obj["CH-O"], obj.CH3NH, obj.CH2NH, obj.CHNH, obj.CH3CN, obj.CH2CN];
    }

    getDadosAntoine() {
        const disponiveis: DadosAntoine[] = [];
        this.substancias.forEach(subs => {
            for(let i = 0; i < this.dadosAntoine.length; i++) {
                if(this.dadosAntoine[i].substancia?.nome == subs.nome) {
                    disponiveis.push(this.dadosAntoine[i]);
                    break;
                }
            }
        });

        return disponiveis;
    }

    getDadosUnifac() {
        const disponiveis: DadosUnifacNorm[] = [];
        this.substancias.forEach(subs => {
            for(let i = 0; i < this.dadosUnifac.length; i++) {
                if(this.dadosUnifac[i].substancia?.nome == subs.nome) {
                    disponiveis.push({
                        substancia: this.dadosUnifac[i].substancia,
                        subgrupos: this.normSubgruposUnifac(this.dadosUnifac[i].subgrupos as SubgrupoUnifac)
                    });
                    break;
                }
            }
        });

        return disponiveis;
    }

    getDadosUA() {
        const disponiveis: DadosUA[] = [];
        this.substancias.forEach(subs => {
            for(let i = 0; i < this.dadosUnifac.length; i++) {
                if(this.dadosUnifac[i].substancia?.nome == subs.nome) {
                    // Verifica se está disponível nos dados antoine
                    for(let j = 0; j < this.dadosAntoine.length; j++) {
                        if(this.dadosAntoine[j].substancia?.nome == subs.nome) {
                            disponiveis.push({
                                antoine: this.dadosAntoine[j],
                                unifac: {
                                    substancia: this.dadosUnifac[i].substancia,
                                    subgrupos: this.normSubgruposUnifac(this.dadosUnifac[i].subgrupos as SubgrupoUnifac)
                                }
                            });
                            break;
                        }
                    }
                    break;
                }
            }
        });

        return disponiveis;
    }

}